import { createApi } from '@reduxjs/toolkit/dist/query/react';
import baseQueryWithReauth from './BaseQueryWithReauth';

export const api = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
}).enhanceEndpoints({
  addTagTypes: ['Addon', 'AppointmentGroup', 'Appointment', 'Industry', 'User', 'Client', 'PriceQuote'],
});
